var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHaiStateNoIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#haiStateNoIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.377.155A6.013 6.013 0 0 0 .155 7.377a5.94 5.94 0 0 0 4.479 4.48 6.013 6.013 0 0 0 7.222-7.223 5.94 5.94 0 0 0-4.48-4.48Zm1.371 8.007-.586.586a.487.487 0 0 1-.686 0L6.348 7.62a.487.487 0 0 0-.685 0L4.534 8.748a.487.487 0 0 1-.685 0l-.586-.586a.487.487 0 0 1 0-.686L4.39 6.348a.487.487 0 0 0 0-.686L3.263 4.534a.487.487 0 0 1 0-.685l.586-.587a.487.487 0 0 1 .685 0l1.129 1.129a.487.487 0 0 0 .685 0l1.128-1.128a.487.487 0 0 1 .686 0l.586.586a.487.487 0 0 1 0 .685L7.62 5.662a.487.487 0 0 0 0 .686l1.128 1.128a.487.487 0 0 1 0 .686Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "haiStateNoIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
})))));
export default SvgHaiStateNoIcon;